module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v2_common/plus-2a40faeeaa67b0814fc5238194193ed8.svg";